import { ValueGetterParams } from 'ag-grid-community';
import { buildTScoped } from 'helpers/translationHelpers';
import { t } from 'i18next';

import { firstNameLastNameFormatter } from 'routes/HumanResourcesModule/components/HrDataGrid/helpers/agentColumnHelpers';
import { orgChartHrFormatter } from 'routes/HumanResourcesModule/components/HrDataGrid/helpers/orgChartHrColumnHelpers';
import { PayComponent } from 'routes/HumanResourcesModule/PayState/helpers/constants';
import { RecurrenceEnum } from 'routes/HumanResourcesModule/Settings/HrPositionMapping/helpers/constants';
import { HypothesisChoice } from '../../AddHypotheses/AgentHypothesisModal/constants';
import {
    AgentPayComponentHypothesis,
    DetailedAgentPayComponentHypothesis,
    SimulationAgentPayComponentData,
} from 'routes/HumanResourcesModule/Simulation/SimulationSynthesis/Agents/components/PayComponent/helpers/types';
import { findExistingAgentPayComponentHypothesis } from 'routes/HumanResourcesModule/Simulation/SimulationSynthesis/Agents/helpers/colDefinitions';
import { SimulationAgentData } from 'routes/HumanResourcesModule/Simulation/SimulationSynthesis/Agents/helpers/types';

const tScoped = buildTScoped(
    'humanResources.simulation.agentHypothesis.creationModal',
);
const modalTitle = (hypothesisType: string | undefined) => {
    if (hypothesisType === undefined) return '';
    if (hypothesisType === HypothesisChoice.PRIME)
        return PayComponent.PONCTUAL_PRIMES;
    if (hypothesisType === HypothesisChoice.DEPARTURE)
        return t('humanResources.simulation.agentHypothesis.departure_other');
    return PayComponent.IFSE_AND_MONTHLY_PRIMES;
};
export const getModalTitle = (
    agentData: SimulationAgentData,
    hypothesisType: string | undefined,
) =>
    hypothesisType === HypothesisChoice.GRADE
        ? tScoped(`gradeHypothesis.title`, {
              agentName: firstNameLastNameFormatter({
                  lastName: agentData.agentLastName,
                  firstName: agentData.agentFirstName,
              }),
          })
        : tScoped(`payComponent.title`, {
              payComponent: modalTitle(hypothesisType),
              agentName: firstNameLastNameFormatter({
                  lastName: agentData.agentLastName,
                  firstName: agentData.agentFirstName,
              }),
              orgChartHr: orgChartHrFormatter({
                  orgChartHrName: agentData.orgChartHrName,
                  orgChartHrMapping: agentData.orgChartHrMapping,
              }),
          });
export const agentPayComponentHypothesisValueGetter =
    (
        agentPayComponentHypotheses:
            | AgentPayComponentHypothesis[]
            | DetailedAgentPayComponentHypothesis[],
    ) =>
    (params: ValueGetterParams<SimulationAgentPayComponentData>) => {
        const { data } = params;
        if (!data) return undefined;
        return findExistingAgentPayComponentHypothesis(
            data,
            agentPayComponentHypotheses,
            data?.recurrence as RecurrenceEnum,
            data?.payComponent,
        );
    };
